import { cn } from '@/shared/utils/cn';

export function CourseCardPresaleTag({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'bg-(--color-primary-500) text-adipa-primary-foreground inline-flex w-fit items-center rounded-md px-2 py-0.5 text-[0.6rem] font-bold uppercase leading-tight tracking-wide',
        className,
      )}
    >
      Pre-lanzamiento
    </span>
  );
}
